import { bytesToNDigits, Space } from '@mail/cross-sizes-utils';
import { ReactElement } from 'react';
import { BASEQUOTA } from 'reactApp/appHelpers/configHelpers';
import { EFeatures } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';

export enum ETariffCardTypes {
    primary = 'primary',
    base = 'base',
}

export interface ITariffCardProps {
    type: ETariffCardTypes;
    productId?: string;
    mainFeature?: EFeatures;
}

export interface ITariffFeature {
    id: string;
    text?: ReactElement | string | null;
    enabled?: boolean;
}

export interface ITariffContent {
    title: string;
    features: ITariffFeature[];
    description: string;
    buttonText: string;
    tariffSpace: Space;
    price?: string;
}

const baseSpace = bytesToNDigits(BASEQUOTA, 3);

export const baseTariffSpace = {
    original: baseSpace?.original || BASEQUOTA,
    units: baseSpace?.units || '_ГБ',
    space: baseSpace?.space || 8,
    value: baseSpace?.value || '8 _  ГБ',
};

export const defaultPrimaryTariff = {
    space: {
        original: 137438953472,
        units: 'ГБ',
        space: 128,
        value: '128 ГБ',
    },
    price: 149,
    hasDiscount: true,
    discountPrice: 1,
};
